import { IStore } from 'store/types';
import { IGetPayPeriodsOptions, IPayPeriod } from 'types';

export const selectPayPeriods =
  ({ orgId, siteId }: IGetPayPeriodsOptions) =>
  (state: IStore): IPayPeriod[] | undefined =>
    state?.collections?.payPeriods?.[orgId]?.[siteId]?.data;
